import React, { useState } from "react";
import { Typography } from "@mui/material";
import { useWindowSize } from "../hooks/useWindowSize";

export default function ShowFullTextOnHover({ text, maxLength = 90 }) {
    const [hover, setHover] = useState(false);
    const displayText = hover ? text : (text.length > maxLength ? text.slice(0, maxLength) + "..." : text);
    const { isMobile } = useWindowSize();
    return (
        <Typography
            component={'span'}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            sx={{ cursor: "pointer" }}
        >
            <Typography variant="caption" component="p" sx={{ color: 'grey.600', fontSize: '0.9rem', textAlign: isMobile ? 'center' : 'left' }}>
                "{displayText}"
            </Typography>
        </Typography>
    );
}